import React, { useState } from "react";
import Slider from "react-slick";
import project1 from "../../assets/project1.png";
import project2 from "../../assets/project2.jpg";
import project3 from "../../assets/project3.jpg";
import project4 from "../../assets/project4.jpg";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { FaArrowRight, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";  // Import motion from framer-motion

const RecentWork = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    { id: 1, title: "Tkambio.us in ReactJS and API | Currency Exchange Calculator", image: project1, link: "https://tkambio.us/", category: "Web Development", description: "I designed, developed, and deployed the website tkambio.us, focusing on a currency exchange calculator that fetches live exchange rates through a custom API built with Node.js and Express.js for real-time conversions. The website supports two languages, English and Spanish, with language management seamlessly handled using React Context for a dynamic and user-friendly experience." },

    { id: 2, title: "InfinitoCapital Develop in ReactJS", image: project2, link: "https://infinitocapital.com/", category: "Web Design & Develop", description: "I developed the Infinito Capital website using ReactJS and TailwindCSS, ensuring a modern and responsive design. To enhance the user experience, I incorporated smooth animations using Framer Motion, adding interactive transitions that bring the website to life. The site is built for performance and scalability, offering a seamless browsing experience across devices while maintaining clean and efficient code." },

    { id: 3, title: "Kamconeng Website Design & Develop", image: project3, link: "https://kamconeng.com/", category: "Design & Develop", description: "I developed kamconeng.com using ReactJS and TailwindCSS and PHP MySQL, creating a responsive and attractive website with a focus on a seamless user experience. I incorporated subtle animations to enhance the visual appeal while ensuring optimal performance across devices. After development, I successfully deployed the website, ensuring it runs smoothly and efficiently in a live environment. Develop Dashboard for dynamic listing." },

    { id: 4, title: "Course Landing Page for Marketing", image: project4, link: "https://celadon-peony-842ca6.netlify.app/", category: "Web Development", description: "I designed and developed a responsive, visually appealing, and SEO-friendly landing page for my client’s online course. The primary focus was on optimizing the page for fast loading to enhance user experience and support effective course marketing.This landing page ensures that my client’s marketing efforts yield maximum impact and drive meaningful results." },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1386,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Open Modal
  const openModal = (project) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  // Close Modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProject(null);
  };

  return (
    <div className="md:ml-[15rem] md:mx-0 mx-4 overflow-hidden my-12 py-12" id="portfolio">
      <span className="bg-[#0788ff33] p-2 uppercase rounded-lg">My Work</span>
      <h2 className="text-3xl font-bold mb-8 mt-3 uppercase">Recent Projects</h2>
      <Slider {...settings}>
        {projects.map((project) => (
          <div key={project.id} className="p-4">
            <div className="rounded-lg overflow-hidden bg-white p-4 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-64 object-cover rounded-lg"
              />
              <div className="mt-3 text-black">
                <div className="flex justify-between items-center">
                  <div>
                    <h3 className="text-xl font-bold">{project.title}</h3>
                    <p className="text-darklight font-semibold">{project.category}</p>
                  </div>
                  <button onClick={() => openModal(project)} className="bg-secondary rounded-full text-white p-3 text-2xl">
                    <FaArrowRight />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      {/* Modal Popup with Framer Motion Animation */}
      {isModalOpen && selectedProject && (
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <motion.div
            className="bg-white p-8 rounded-lg w-full max-w-lg relative"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.8 }}
            transition={{ duration: 0.3 }}
          >
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-2xl text-gray-600"
            >
              <FaTimes />
            </button>
            <h2 className="text-3xl font-semibold mb-4">{selectedProject.title}</h2>
            <img
              src={selectedProject.image}
              alt={selectedProject.title}
              className="w-full h-48 object-cover rounded-lg mb-4"
            />
            <p className="text-lg text-black mb-4">{selectedProject.description}</p>
            <Link
            target="_blank"
              to={selectedProject.link}
              className="text-lg text-blue-500 hover:underline"
            >
              Go to website
            </Link>
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};

export default RecentWork;
